class ProductVariants extends HTMLElement {
  constructor() {
    super();
    this.updateURL = false;
    this.productHandle = null;
    this.sectionId = null;
    this.productId = null;
    this.productCard = false;
    this.cartProduct = this.dataset.cartProduct;
    this.itemKey = this.dataset.itemKey;
    this.productTemplate = this.dataset.template;
    this.oldVariantId = this.dataset.variantId;
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.addEventListener("change", (event) => this.handleVariantChange(event));
  }

  async handleVariantChange(e) {
    if (e.target.tagName === "SELECT") {
      const selectElement = e.target;
      const selectedOption = selectElement.options[selectElement.selectedIndex];
      this.productHandle = selectedOption.dataset.productHandle;
      this.sectionId = selectedOption.dataset.sectionId;
      this.productId = selectedOption.dataset.productId;
      this.productCard = !this.cartProduct;
    } else if (e.target.dataset.colorSwatch) {
      this.productHandle = e.target.dataset.productHandle;
      this.sectionId = e.target.dataset.sectionId;
      this.productId = e.target.dataset.productId;
      this.productCard = true;
    } else {
      this.productHandle = e.target.dataset.productHandle;
      this.sectionId = e.target.dataset.sectionId;
      this.productId = e.target.dataset.productId;
      if (window.location.href.includes("/collections")) {
        this.productCard = true;
      } else {
        this.productCard = false;
      }
    }

    // Check if we're on a product page
    this.updateURL = window.location.pathname.includes("/products/");

    if (e.target.tagName === "SELECT") {
      this.currentVariant = this.getProductFromSelect();
    } else if (e.target.type === "radio") {
      this.currentVariant = this.getProductFromRadios(e);
    }
    if (this.currentVariant) {
      if (!this.productCard && this.updateURL) this.updateProductURL();
      await this.fetchProductInfo();
      if (this.productTemplate === "volume-discount-mrp") {
        this.updatesForVolumeDiscount();
      }
      if (
        window.location.href.includes("/products") &&
        this.currentVariant[0].available
      ) {
        let customPincode = document.querySelector("pincode-element");
        if (customPincode) {
          pincodeFunctionality();
          document
            .querySelector("pincode-element #pincodeInput")
            ?.addEventListener("input", () => {
              document
                .querySelector(".pincode-failure")
                .classList.add("hidden");
              if (document.querySelector(".add-to-cart-btn")) {
                document
                  .querySelector(".add-to-cart-btn")
                  .removeAttribute("disabled");
              }
              document.querySelector(".pincode-output").style.display = "none";
              document
                .querySelector(".pincode-button")
                .removeAttribute("disabled");
              document.querySelector(".pincode-button").innerHTML = "Check";
              if (
                document.querySelector("pincode-element #pincodeInput").length <
                6
              ) {
                window.isPincodeFetched = false;
              }
            });
        } else {
          this.handlePincode();
        }
      }
    } else {
      this.setUnavailable();
    }
  }

  handlePincode() {
    document
      .querySelector("input[name=drop_pincode]")
      .addEventListener("input", (e) => {
        document
          .querySelector(".response-container")
          .classList.add("tw-hidden");
        window.isPincodeFetched = false;
        document.querySelector(".pincode-failure").classList.add("hidden");
      });

    var pdpClickpostForm = document.querySelector(".clickpost-edd__form");
    const dropPincode = sessionStorage.getItem("drop_pincode");

    if (dropPincode) {
      pdpClickpostForm.querySelector('input[name="drop_pincode"]').value =
        dropPincode;
    }

    if (pdpClickpostForm) {
      var pincode = pdpClickpostForm.querySelector(
        'input[name="drop_pincode"]'
      ).value;

      if (this.currentVariant[0].available) {
        if (pincode) {
          window.globalFetchEdd(pincode);
        }
      } else {
        document
          .querySelector(".pincode-button")
          .setAttribute("disabled", true);
      }

      document
        .querySelector(".pincode-button")
        .addEventListener("click", (e) => {
          e.preventDefault();
          var pincode = pdpClickpostForm.querySelector(
            'input[name="drop_pincode"]'
          ).value;
          window.globalFetchEdd(pincode);
        });
    }
  }

  updatesForVolumeDiscount() {
    document.querySelectorAll(".volume-discount-wrapper")?.forEach((div) => {
      if (div.getAttribute("data-vd-variant-id") == this.currentVariant.id) {
        volumeDiscountWrapper = div;
      }
    });
    if (volumeDiscountWrapper) {
      volumeDiscountInventoryQuantities = volumeDiscountWrapper?.getAttribute(
        "data-inventory-quantity"
      );
      document
        .querySelectorAll(".volume-discount-variant-card")
        ?.forEach((card) => {
          card.addEventListener("click", () => {
            clickHandlerForVolumeDiscountVariants(card);
            // Reset the selected card to ensure clean state between selections
            selectedVolumeDiscountCard = null;
          });
        });
    }
  }

  getProductFromRadios(event) {
    this.productVariant = event.target.closest("product-variants");
    const selectedVariants = Array.from(
      this.productVariant.querySelectorAll('input[type="radio"]:checked')
    ).map((radio) => {
      const scriptTag = radio.nextElementSibling;
      let variantData;
      if (scriptTag && scriptTag.tagName === "SCRIPT") {
        try {
          variantData = JSON.parse(scriptTag.textContent);
        } catch (e) {
          console.warn("Invalid JSON in script tag", e);
        }
      }
      return variantData;
    });
    return selectedVariants;
  }

  getProductFromSelect() {
    const selects = Array.from(this.querySelectorAll("select"));
    const selectedVariants = selects.map((select) => {
      const selectedOption = select.options[select.selectedIndex];
      const scriptTag = selectedOption.nextElementSibling;
      let variantData;
      if (scriptTag) {
        variantData = JSON.parse(scriptTag.textContent);
      }
      return variantData;
    });
    return selectedVariants;
  }

  updateProductURL() {
    this.url = new URL(window.location);
    const currentPathParts = this.url.pathname.split("/");
    if (currentPathParts.length > 2) {
      currentPathParts[2] = this.productHandle; // Assuming the product handle is always at index 2
    }
    this.url.pathname = currentPathParts.join("/");
    let urlVariantId = this.currentVariant[0].id || this.currentVariant.id;
    this.url.searchParams.set("variant", urlVariantId);
    window.history.replaceState({}, "", this.url);
  }

  async fetchProductInfo() {
    if (this.closest("borosil-xs-card")) {
      this.url = `/products/${this.productHandle}?variant=${this.currentVariant.id}&sections=borosil-xs-product-variant-card`;

      try {
        const response = await fetch(this.url);
        const responseJson = await response.json();
        const rawHTML = responseJson["borosil-xs-product-variant-card"];
        const decodedHTML = rawHTML
          .replace(/&quot;/g, '"') // Replace &quot; with "
          .replace(/\\n/g, "") // Remove \n
          .replace(/\\&quot;/g, '"') // Handle escaped quotes within backslashes
          .replace(/&#39;/g, "'");
        this.html = new DOMParser().parseFromString(decodedHTML, "text/html");
        this.renderProductInfo(this.html);

        // Flits earn credit window object
        // window.flitsThemeAppExtensionObjects.product.product_handle =
        //   this.productHandle;
        // window.refreshFlitsCredits(this.currentVariant.id);
      } catch (error) {
        console.error("Error fetching product info:", error);
      }
    } else if (this.productCard) {
      this.url = `/products/${this.productHandle}?variant=${this.currentVariant.id}&sections=borosil-product-card-render`;
      try {
        const response = await fetch(this.url);
        const responseJson = await response.json();
        const rawHTML = responseJson["borosil-product-card-render"];
        const decodedHTML = rawHTML
          .replace(/&quot;/g, '"') // Replace &quot; with "
          .replace(/\\n/g, "") // Remove \n
          .replace(/\\&quot;/g, '"')
          .replace(/&#39;/g, "'"); // Handle escaped quotes within backslashes
        this.html = new DOMParser().parseFromString(decodedHTML, "text/html");
        this.renderProductInfo(this.html);

        // Flits earn credit window object
        // window.flitsThemeAppExtensionObjects.product.product_handle =
        //   this.productHandle;
        // window.refreshFlitsCredits(this.currentVariant.id);
      } catch (error) {
        console.error("Error fetching product info:", error);
      }
    } else if (this.cartProduct) {
      try {
        await this.addVariantToCart(this.currentVariant.id);

        // Optionally, remove the old variant if needed
        // await this.removeOldVariantFromCart(this.oldVariantId);
      } catch (error) {
        console.error("Error fetching cart info:", error);
      }
    } else {
      this.url = `/products/${this.productHandle}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`;
      try {
        const response = await fetch(this.url);
        const responseText = await response.text();
        this.html = new DOMParser().parseFromString(responseText, "text/html");
        this.renderProductInfo(this.html);

        // Flits earn credit window object
        window.flitsThemeAppExtensionObjects.product.product_handle =
          this.productHandle;
        window.refreshFlitsCredits(this.currentVariant.id);
      } catch (error) {
        console.error("Error fetching product info:", error);
      }
    }
  }

  parseHTMLJSON(str) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = str;
    try {
      return JSON.parse(textarea.value);
    } catch (e) {
      console.error(
        "Failed to parse JSON from HTML string:",
        e,
        textarea.value
      );
      return null;
    }
  }

  renderProductInfo(section) {
    const productCard = this.closest("borosil-product-card");

    const xsCard = this.closest("borosil-xs-card");
    const updatedContent = section.querySelector(
      `[data-product-variant-handle="${this.productHandle}"]`
    );
    if (
      this.productCard &&
      productCard &&
      productCard.dataset.view === "single" &&
      window.location.href.includes("/collections")
    ) {
      // Handle 'single' view updates (partial, preserving listeners)
      const productImageWrapper = productCard.querySelector(
        ".product-card__image"
      );
      const newImg = updatedContent?.querySelector("img");
      if (productImageWrapper && newImg) {
        productImageWrapper.src = newImg.src;
        if (newImg.srcset) productImageWrapper.srcset = newImg.srcset;
        if (newImg.alt) productImageWrapper.alt = newImg.alt;
      }

      const replaceText = (selector) => {
        const oldEl = productCard.querySelector(selector);
        const newEl = updatedContent.querySelector(selector);
        if (oldEl && newEl) oldEl.innerHTML = newEl.innerHTML;
      };

      replaceText(".product__card__title");
      replaceText(".compare-at-price");
      replaceText(".selling-price");
      replaceText(".discount-percentage");

      const productForm = productCard.querySelector("product-form");
      const updatedForm = updatedContent.querySelector("product-form");

      if (productForm && updatedForm) {
        productForm.id = updatedForm.id;
        productForm.querySelector("input[name=id]").value =
          updatedForm.querySelector("input[name=id]").value;
        productForm.querySelector("button[name=add]").id =
          updatedForm.querySelector("button[name=add]").id;
        productForm.querySelector("input[name=product-id]").value =
          updatedForm.querySelector("input[name=product-id]").value;
      }

      const colorVariants = productCard.querySelectorAll(
        'input[name="product-as-variants-color"]'
      );

      const updatedColorVariants = updatedContent.querySelectorAll(
        ".product__color__variants"
      );
      const sizeVariants = productCard.querySelectorAll(
        'input[name="product-as-variants"]'
      );
      const updatedSizeVariants = updatedContent.querySelectorAll(
        ".product__size__variants"
      );
      const productVariantElementSize = this.classList.contains(
        "horizontal-size-variants"
      )
        ? this
        : null;
      const productVariantElement = this.classList.contains(
        "horizontal-color-variants"
      )
        ? this
        : null;

      let horizontalsizevariants = productCard.querySelector(
        ".horizontal-size-variants"
      );

      let horizontalcolorvariants = productCard.querySelector(
        ".horizontal-color-variants"
      );
      let uniqueIndexNumber;
      if (productCard.querySelector("input[name=product-as-variants]")) {
        uniqueIndexNumber = productCard.querySelector(
          "input[name=product-as-variants]"
        ).dataset.uniqueIndex;
      }

      if (
        colorVariants.length &&
        updatedColorVariants.length &&
        productVariantElement
      ) {
        let newSizeElements;
        // Build the new structure without touching DOM yet
        const newElements = Array.from(updatedColorVariants).flatMap(
          (updatedInput) => {
            const variantsBlock =
              updatedInput.querySelector("product-variants");
            if (!variantsBlock) return [];

            const inputs = variantsBlock.querySelectorAll(
              'input[type="radio"]'
            );

            return Array.from(inputs).map((input, index) => {
              const scriptTag = input.nextElementSibling?.nextElementSibling;
              let variantData = {};

              if (scriptTag && scriptTag.tagName === "SCRIPT") {
                try {
                  variantData = JSON.parse(scriptTag.textContent);
                } catch (err) {
                  console.warn("Error parsing variant JSON", err);
                }
              }
              const newInput = document.createElement("input");
              newInput.type = "radio";
              newInput.name = "product-as-variants-color";
              newInput.setAttribute("data-unique-id", uniqueIndexNumber);
              newInput.className =
                "product__variant__swatches__input tw-w-[0.1rem] tw-h-[0.1rem] tw-overflow-hidden tw-hidden";
              newInput.id = `color-${
                variantData.id
              }-${updatedContent.getAttribute("id")}-${uniqueIndexNumber}`;
              newInput.value = variantData.id;
              newInput.setAttribute("data-product-handle", variantData.handle);
              newInput.setAttribute(
                "data-section-id",
                input.dataset.sectionId || ""
              );
              if (input.dataset.productCard) {
                newInput.setAttribute("data-product-card", "true");
              }
              if (input.checked) newInput.checked = true;
              if (!variantData.available) {
                newInput.disabled = true;
              }
              const label = document.createElement("label");
              label.setAttribute("for", newInput.id);
              label.setAttribute("data-variant-id", variantData.id);
              label.className = `product-as-variants-color-label tw-max-w-[8.2rem] color-${uniqueIndexNumber} !tw-p-0 !tw-rounded-none `;
              if (
                variantData.id == updatedContent.getAttribute("id") &&
                variantData.available
              ) {
                label.className += "product-as-variants-label checked";

                let sizeVariantsInput = document.querySelectorAll(
                  `input[name=product-as-variants][data-unique-index="${uniqueIndexNumber}"]`
                );

                let colorVariantsInputs = document.querySelectorAll(
                  `input[name=product-as-variants-color][data-unique-id="${uniqueIndexNumber}"]`
                );

                sizeVariantsInput.forEach((sizeVariant) => {
                  sizeVariant.removeAttribute("checked");
                });
                colorVariantsInputs.forEach((colorVariant) => {
                  colorVariant.removeAttribute("checked");
                });

                document
                  .querySelectorAll(
                    `.product-as-variants-label.size-${uniqueIndexNumber}`
                  )
                  .forEach((size) => {
                    size.classList.remove("checked");
                  });
                sizeVariantsInput.forEach((sizeVariant) => {
                  if (sizeVariant.value == variantData.id) {
                    sizeVariant.setAttribute("checked", "checked");

                    document
                      .querySelector(
                        `.product-as-variants-label.size-${uniqueIndexNumber}[data-variant-id="${variantData.id}"]`
                      )
                      .classList.add("checked");
                  }
                });

                // color variant label
                const matchingColorLabel = document.querySelector(
                  `.product-as-variants-color-label.color-${uniqueIndexNumber}[data-variant-id="${variantData.id}"]`
                );
                if (matchingColorLabel) {
                  matchingColorLabel.classList.add("checked");
                }
              }
              if (!variantData.available) {
                label.className +=
                  "product-as-variants-label disabled-variant tw-opacity-50 disabled product__color__variant";
              }
              const div = document.createElement("div");
              div.classList.add(..."tw-w-full tw-h-full".split(" "));
              const img = document.createElement("img");
              img.src = variantData.featured_image || "";
              img.alt = variantData.title || "Color Variant";
              img.loading = "lazy";

              div.appendChild(img);
              label.appendChild(div);

              // Update Size Variant as well
              newSizeElements = Array.from(updatedSizeVariants).flatMap(
                (updatedInput) => {
                  const variantsBlocks =
                    updatedInput.querySelectorAll("product-variants");

                  if (!variantsBlocks.length) return [];

                  const options = Array.from(variantsBlocks)
                    .filter(
                      (block) => block.querySelectorAll("option").length > 0
                    )
                    .flatMap((block) =>
                      Array.from(block.querySelectorAll("option"))
                    );

                  return Array.from(options).map((input) => {
                    const scriptTag = input.nextElementSibling;
                    let variantData = {};

                    if (scriptTag && scriptTag.tagName === "SCRIPT") {
                      try {
                        variantData = JSON.parse(scriptTag.textContent);
                      } catch (err) {
                        console.warn("Error parsing size variant JSON", err);
                      }
                    }
                    const newInput = document.createElement("input");
                    newInput.type = "radio";
                    newInput.name = "product-as-variants";
                    newInput.className =
                      "product__variant__swatches__input tw-w-[0.1rem] tw-h-[0.1rem] tw-overflow-hidden tw-hidden";
                    newInput.id = `variant-${
                      variantData.id
                    }-${updatedContent.getAttribute(
                      "id"
                    )}-${uniqueIndexNumber}`;
                    newInput.value = variantData.id;
                    newInput.setAttribute(
                      "data-product-handle",
                      variantData.handle
                    );
                    newInput.setAttribute(
                      "data-section-id",
                      input.dataset.sectionId || ""
                    );
                    newInput.setAttribute("data-variant-id", variantData.id);
                    newInput.setAttribute(
                      "data-unique-index",
                      uniqueIndexNumber
                    );
                    if (input.dataset.productCard) {
                      newInput.setAttribute("data-product-card", "true");
                    }
                    if (input.checked) newInput.checked = true;

                    if (!variantData.available) {
                      newInput.disabled = true;
                    }

                    const label = document.createElement("label");
                    label.setAttribute("for", newInput.id);
                    label.setAttribute("data-variant-id", variantData.id);
                    label.className = `product__size__variant size-${uniqueIndexNumber} tw-cursor-pointer product-as-variants-label`;
                    if (
                      variantData.id == updatedContent.getAttribute("id") &&
                      variantData.available
                    ) {
                      label.className = `product__size__variant size-${uniqueIndexNumber} product-as-variants-label checked`;
                    }
                    if (!variantData.available) {
                      label.className = `product__size__variant size-${uniqueIndexNumber}  product-as-variants-label disabled-variant`;
                    }
                    if (variantData.available) {
                      label.textContent = variantData.variants[0].option1;
                    } else {
                      label.textContent = `${variantData.variants[0].option1} - Sold out`;
                    }

                    return { input: newInput, label };
                  });
                }
              );
              return { input: newInput, label };
            });
          }
        );

        // Diffing logic: Replace or update only if necessary
        newElements.forEach(({ input: newInput, label: newLabel }) => {
          const existingInput = productVariantElement.querySelector(
            `#${newInput.id}`
          );
          const existingLabel = productVariantElement.querySelector(
            `label[for="${newInput.id}"]`
          );

          if (!existingInput) {
            // New variant, append both input and label
            productVariantElement.appendChild(newInput);
            productVariantElement.appendChild(newLabel);
          } else {
            // Variant exists, optionally update image if needed
            const existingImg = existingLabel?.querySelector("img");
            const newImg = newLabel.querySelector("img");

            if (
              existingImg &&
              newImg &&
              (existingImg.src !== newImg.src || existingImg.alt !== newImg.alt)
            ) {
              existingImg.src = newImg.src;
              existingImg.alt = newImg.alt;
            }

            // Sync checked state
            existingInput.checked = newInput.checked;
          }
        });

        // Remove stale inputs not in the new set
        const newIds = newElements.map(({ input }) => input.id);
        const existingInputs = Array.from(
          productVariantElement.querySelectorAll(
            'input[name="product-as-variants-color"]'
          )
        );

        existingInputs.forEach((input) => {
          if (!newIds.includes(input.id)) {
            const label = productVariantElement.querySelector(
              `label[for="${input.id}"]`
            );
            input.remove();
            if (label) label.remove();
          }
        });

        // Diffing logic for size variants
        newSizeElements.forEach(({ input: newInput, label: newLabel }) => {
          const existingInput = horizontalsizevariants.querySelector(
            `#${newInput.id}`
          );
          const existingLabel = horizontalsizevariants.querySelector(
            `label[for="${newInput.id}"]`
          );

          if (!existingInput) {
            horizontalsizevariants.appendChild(newInput);
            horizontalsizevariants.appendChild(newLabel);
          } else {
            existingInput.checked = newInput.checked;
            // Optionally update label text
            if (
              existingLabel &&
              existingLabel.textContent !== newLabel.textContent
            ) {
              existingLabel.textContent = newLabel.textContent;
            }
          }
        });

        // Remove stale size inputs
        const newSizeIds = newSizeElements.map(({ input }) => input.id);
        const existingSizeInputs = Array.from(
          horizontalsizevariants.querySelectorAll(
            'input[name="product-as-variants"]'
          )
        );

        existingSizeInputs.forEach((input) => {
          if (!newSizeIds.includes(input.id)) {
            const label = horizontalsizevariants.querySelector(
              `label[for="${input.id}"]`
            );
            input.remove();
            if (label) label.remove();
          }
        });
      }

      if (
        sizeVariants.length &&
        updatedSizeVariants.length &&
        productVariantElementSize
      ) {
        let newColorElements;
        const newSizeElements = Array.from(updatedSizeVariants).flatMap(
          (updatedInput) => {
            const variantsBlocks =
              updatedInput.querySelectorAll("product-variants");

            if (!variantsBlocks.length) return [];

            const options = Array.from(variantsBlocks)
              .filter((block) => block.querySelectorAll("option").length > 0)
              .flatMap((block) => Array.from(block.querySelectorAll("option")));

            return Array.from(options).map((input) => {
              const scriptTag = input.nextElementSibling;
              let variantData = {};

              if (scriptTag && scriptTag.tagName === "SCRIPT") {
                try {
                  variantData = JSON.parse(scriptTag.textContent);
                } catch (err) {
                  console.warn("Error parsing size variant JSON", err);
                }
              }
              const newInput = document.createElement("input");
              newInput.type = "radio";
              newInput.name = "product-as-variants";
              newInput.className =
                "product__variant__swatches__input tw-w-[0.1rem] tw-h-[0.1rem] tw-overflow-hidden tw-hidden";
              newInput.id = `variant-${
                variantData.id
              }-${updatedContent.getAttribute("id")}-${uniqueIndexNumber}`;
              newInput.value = variantData.id;
              newInput.setAttribute("data-product-handle", variantData.handle);
              newInput.setAttribute(
                "data-section-id",
                input.dataset.sectionId || ""
              );
              newInput.setAttribute("data-variant-id", variantData.id);
              newInput.setAttribute("data-unique-index", uniqueIndexNumber);
              if (input.dataset.productCard) {
                newInput.setAttribute("data-product-card", "true");
              }
              if (input.checked) newInput.checked = true;

              if (!variantData.available) {
                newInput.disabled = true;
              }

              const label = document.createElement("label");
              label.setAttribute("for", newInput.id);
              label.setAttribute("data-variant-id", variantData.id);
              label.className = `product__size__variant size-${uniqueIndexNumber} tw-cursor-pointer product-as-variants-label`;
              if (
                variantData.id == updatedContent.getAttribute("id") &&
                variantData.available
              ) {
                // updating the selected variant
                // First clear both size and color input as well as label
                let colorVariantsInputs = document.querySelectorAll(
                  `input[name=product-as-variants-color][data-unique-id="${uniqueIndexNumber}"]`
                );

                if (colorVariantsInputs) {
                  colorVariantsInputs.forEach((colorVariant) => {
                    colorVariant.removeAttribute("checked");
                  });

                  let colorVariantsLabels = document.querySelectorAll(
                    `.product-as-variants-color-label.color-${uniqueIndexNumber}`
                  );

                  colorVariantsLabels.forEach((label) => {
                    label.classList.remove("checked");
                  });
                }

                let sizeVariantsInput = document.querySelectorAll(
                  `input[name=product-as-variants][data-unique-index="${uniqueIndexNumber}]"`
                );
                let sizeVariantLabels = document.querySelectorAll(
                  `.product-as-variants-label.size-${uniqueIndexNumber}`
                );
                sizeVariantsInput.forEach((input) => {
                  input.removeAttribute("checked");
                });
                sizeVariantLabels.forEach((label) => {
                  label.classList.remove("checked");
                });

                sizeVariantsInput.forEach((input) => {
                  if (input.value == variantData.id) {
                    input.setAttribute("checked", true);
                  }
                });

                colorVariantsInputs.forEach((input) => {
                  if (input.dataset.variantId == variantData.id) {
                    input.setAttribute("checked", true);
                  }
                });

                const matchingColorLabel = document.querySelector(
                  `.product-as-variants-color-label.color-${uniqueIndexNumber}[data-variant-id="${variantData.id}"]`
                );
                if (matchingColorLabel) {
                  matchingColorLabel.classList.add("checked");
                }

                const matchingSizeLabel = document.querySelector(
                  `.product-as-variants-label.size-${uniqueIndexNumber}[data-variant-id="${variantData.id}"]`
                );
                if (matchingSizeLabel) {
                  matchingSizeLabel.classList.add("checked");
                }

                label.className = `product__size__variant size-${uniqueIndexNumber} product-as-variants-label checked`;
              }
              if (!variantData.available) {
                label.className = `product__size__variant size-${uniqueIndexNumber}  product-as-variants-label disabled-variant tw-line-through`;
              }
              if (variantData.available) {
                label.textContent = variantData.variants[0].option1;
              } else {
                label.textContent = `${variantData.variants[0].option1} - Sold out`;
              }

              // Update color variant as well
              newColorElements = Array.from(updatedColorVariants).flatMap(
                (updatedInput) => {
                  const variantsBlock =
                    updatedInput.querySelector("product-variants");
                  if (!variantsBlock) return [];

                  const inputs = variantsBlock.querySelectorAll(
                    'input[type="radio"]'
                  );

                  return Array.from(inputs).map((input, index) => {
                    const scriptTag =
                      input.nextElementSibling?.nextElementSibling;
                    let variantData = {};

                    if (scriptTag && scriptTag.tagName === "SCRIPT") {
                      try {
                        variantData = JSON.parse(scriptTag.textContent);
                      } catch (err) {
                        console.warn("Error parsing variant JSON", err);
                      }
                    }
                    const newInput = document.createElement("input");
                    newInput.type = "radio";
                    newInput.name = "product-as-variants-color";
                    newInput.setAttribute("data-unique-id", uniqueIndexNumber);
                    newInput.className =
                      "product__variant__swatches__input tw-w-[0.1rem] tw-h-[0.1rem] tw-overflow-hidden tw-hidden";
                    newInput.id = `color-${
                      variantData.id
                    }-${updatedContent.getAttribute(
                      "id"
                    )}-${uniqueIndexNumber}`;
                    newInput.value = variantData.id;
                    newInput.setAttribute(
                      "data-product-handle",
                      variantData.handle
                    );
                    newInput.setAttribute(
                      "data-section-id",
                      input.dataset.sectionId || ""
                    );
                    if (input.dataset.productCard) {
                      newInput.setAttribute("data-product-card", "true");
                    }
                    if (input.checked) newInput.checked = true;
                    if (!variantData.available) {
                      newInput.disabled = true;
                    }
                    const label = document.createElement("label");
                    label.setAttribute("for", newInput.id);
                    label.setAttribute("data-variant-id", variantData.id);
                    label.className = `product-as-variants-color-label tw-max-w-[8.2rem] color-${uniqueIndexNumber} !tw-p-0 !tw-rounded-none `;
                    if (
                      variantData.id == updatedContent.getAttribute("id") &&
                      variantData.available
                    ) {
                      label.className += "product-as-variants-label checked";
                    }
                    if (!variantData.available) {
                      label.className +=
                        " product-as-variants-label disabled-variant disabled tw-opacity-50 product__color__variant";
                    }
                    const div = document.createElement("div");
                    div.classList.add(..."tw-w-full tw-h-full".split(" "));
                    const img = document.createElement("img");
                    img.src = variantData.featured_image || "";
                    img.alt = variantData.title || "Color Variant";
                    img.loading = "lazy";

                    div.appendChild(img);
                    label.appendChild(div);
                    return { input: newInput, label };
                  });
                }
              );
              return { input: newInput, label };
            });
          }
        );

        // Diffing logic for size variants
        newSizeElements.forEach(({ input: newInput, label: newLabel }) => {
          const existingInput = productVariantElementSize.querySelector(
            `#${newInput.id}`
          );
          const existingLabel = productVariantElementSize.querySelector(
            `label[for="${newInput.id}"]`
          );

          if (!existingInput) {
            productVariantElementSize.appendChild(newInput);
            productVariantElementSize.appendChild(newLabel);
          } else {
            existingInput.checked = newInput.checked;
            // Optionally update label text
            if (
              existingLabel &&
              existingLabel.textContent !== newLabel.textContent
            ) {
              existingLabel.textContent = newLabel.textContent;
            }
          }
        });

        // Remove stale size inputs
        const newSizeIds = newSizeElements.map(({ input }) => input.id);
        const existingSizeInputs = Array.from(
          productVariantElementSize.querySelectorAll(
            'input[name="product-as-variants"]'
          )
        );

        existingSizeInputs.forEach((input) => {
          if (!newSizeIds.includes(input.id)) {
            const label = productVariantElementSize.querySelector(
              `label[for="${input.id}"]`
            );
            input.remove();
            if (label) label.remove();
          }
        });

        // Diffing logic for color Variants

        newColorElements.forEach(({ input: newInput, label: newLabel }) => {
          const existingInput = horizontalcolorvariants.querySelector(
            `#${newInput.id}`
          );
          const existingLabel = horizontalcolorvariants.querySelector(
            `label[for="${newInput.id}"]`
          );

          if (!existingInput) {
            // New variant, append both input and label
            horizontalcolorvariants.appendChild(newInput);
            horizontalcolorvariants.appendChild(newLabel);
          } else {
            // Variant exists, optionally update image if needed
            const existingImg = existingLabel?.querySelector("img");
            const newImg = newLabel.querySelector("img");

            if (
              existingImg &&
              newImg &&
              (existingImg.src !== newImg.src || existingImg.alt !== newImg.alt)
            ) {
              existingImg.src = newImg.src;
              existingImg.alt = newImg.alt;
            }

            // Sync checked state
            existingInput.checked = newInput.checked;
          }
        });

        // Remove stale inputs not in the new set
        const newIds = newColorElements.map(({ input }) => input.id);
        const existingInputs = Array.from(
          horizontalcolorvariants.querySelectorAll(
            'input[name="product-as-variants-color"]'
          )
        );

        existingInputs.forEach((input) => {
          if (!newIds.includes(input.id)) {
            const label = horizontalcolorvariants.querySelector(
              `label[for="${input.id}"]`
            );
            input.remove();
            if (label) label.remove();
          }
        });
      }
    } else if (this.productCard && productCard) {
      this.currentProductHandle = productCard.dataset.productVariantHandle;
      productCard.innerHTML = updatedContent.innerHTML;
    } else if (xsCard) {
      this.currentProductHandle = xsCard.dataset.productVariantHandle;
      xsCard.innerHTML = updatedContent.innerHTML;
    } else {
      // Default fallback for main product area
      const mainProduct = document.querySelector(".main-product");
      if (mainProduct && section.querySelector(".main-product")) {
        mainProduct.innerHTML =
          section.querySelector(".main-product").innerHTML;
        mainProduct.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  }

  setUnavailable() {
    const productForm = document.getElementById(
      `product-form--${this.sectionId}--${this.productId}`
    );
    const addButtonText = productForm.querySelector(
      '[name="add"] > .button--atc__text'
    );
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );

    if (addButtonText) addButtonText.textContent = "Unavailable";
    [price, inventory, sku, pricePerItem].forEach((el) =>
      el?.classList.add("visibility-hidden")
    );
  }

  async addVariantToCart(variantId) {
    const body = JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: 1, // Adjust quantity as needed
        },
      ],
    });

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: body,
      });

      if (!response.ok) throw new Error("Failed to add variant to cart");
      const data = await response.json();
      this.cart.renderContents(response);
    } catch (error) {
      console.error("Error adding variant to cart:", error);
    }
  }

  async removeOldVariantFromCart(oldVariantId) {
    const body = JSON.stringify({
      updates: {
        [oldVariantId]: 0, // Set quantity to 0 to remove the old variant
      },
    });

    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: body,
      });

      if (!response.ok)
        throw new Error("Failed to remove old variant from cart");
      const data = await response.json();
    } catch (error) {
      console.error("Error removing old variant from cart:", error);
    }
  }
}

customElements.define("product-variants", ProductVariants);
